import React from "react";
import AboutSoftwareServices from "./AboutSoftwareServices";

function aboutSoftwareServices() {
    const features = [
        {
            icon: "fi fi-rr-document",
            title: "Разработка программного обеспечения",
            text: `Проектирование, разработка, внедрение и сопровождение программных продуктов: веб-приложения, бизнес-аналитика, ГИС, мобильные приложения. 
Создание решений для сбора, хранения, анализа и визуализации пространственных данных на базе картографических сервисов (OSM и другие).`
        },
        {
            icon: "mobi-mbri-setting",
            title: "Сопровождение программного обеспечения",
            text: `Техническая поддержка, обновление и модификация решений, обеспечение совместимости с различными платформами и ОС.`
        },
        {
            icon: "mobi-mbri-database",
            title: "Обработка и хранение данных",
            text: `Разработка и эксплуатация платформ хранения Big Data, автоматизация обработки и анализа гео-данных.`
        },
        {
            icon: "mobi-mbri-info",
            title: "Консультации в области ИТ",
            text: `Консультации по проектированию и внедрению ИТ-решений в сферах: госуправление, торговля, недвижимость, транспорт и др.`
        }
    ];

    return <AboutSoftwareServices features={features} />;
}

const HomeIT = () => {
    return (
        <>
            {aboutSoftwareServices()}
        </>
    );
};

HomeIT.link = "/it-services";

export default HomeIT;
